import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const ForgotText = styled.a`
  font-size: 12px;
  font-weight: 400;
  display: flex;
  justify-content: center;
  margin-top: 9px;
  margin-bottom: 10px;
  color: ${Colors.ORANGELOGIN};
`;

const line = styled.div`
  border-bottom: 1px solid ${Colors.greyOutline};
  width: 70%;
  marginbottom: 20px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Title = styled.div`
  font-size: 22px;
  font-weight: 700;
  font-height: 120%;
  margin-bottom: 32px;
  margin-top: 120px;
`;

const TitleLeft = styled.div`
  font-size: 21px;
  font-weight: 700;
  font-height: 120%;
  color: white;
`;

const SubTitleRight = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
`;

const SubTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  margin-bottom: 5px;
`;

const NoAccountText = styled.p`
  margin-top: 29px;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: ${Colors.text_primary};
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  /* font-family: SF Pro Text; */
`;

const formContainer = styled.div`
  min-height: 100vh;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const form = styled.div`
  width: 50%;
  margin-top: -150px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 24px;
  }
`;

const headerContainer = styled.div`
  width: 80%;
  height: 70px;
  position: absolute;
  right: 0;
  left: 0;
  margin: auto;
  z-index: 100;
  padding: 40px 0px 0 0px;
  display: flex;
  justify-content: space-between;
  color: white;
  @media (max-width: 768px) {
    width: 100%;
    padding: 40px 24px 0px;
  }
`;

const imageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  height: 80%;
  margin-top: 120px;
`;

const textContainer = styled.div`
  height: 20%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 10px;
`;

const register = styled.a`
  color: ${Colors.primary};
`;

export default {
  ForgotText,
  line,
  Title,
  TitleLeft,
  SubTitleRight,
  SubTitle,
  NoAccountText,
  formContainer,
  form,
  headerContainer,
  imageContainer,
  textContainer,
  register,
};
